import dayjs from 'dayjs'
import { callApi } from '@local_modules/generic/fetch.js'
import { setElementHtml, showElement } from '../../../../helpers/generic-js/dom.js'

/**
 *
 * @param {Object} context
 * @param {String} context.showOrgId
 * @param {Object} [context.dates]
 * @param {String} [context.dates.min]
 * @param {String} [context.dates.max]
 * @returns
 */
export async function loadDataMonthlyValues (context) {
  console.log('loadDataMonthlyValuesPGLedger')
  // console.log('context', context)
  // console.log('context.showOrgId', context.showOrgId)

  if (!context.showOrgId) return

  // The orgIds to fetch data for
  const orgIds = []
  if (!Array.isArray(context.showOrgId)) {
    orgIds.push(context.showOrgId)
  } else {
    orgIds.push(...context.showOrgId)
    document.getElementById('progressBar')?.setAttribute('value', 0)
  }

  // Load the data for each entity
  const promises = []
  for (const orgId of orgIds) {
    const orgData = getOrgData(context, orgId)

    const promise = loadOneEntity(orgId, context.dates, orgData, {
      numberProgressStep: orgIds.length
    })
    promises.push(promise)
  }

  const results = {
    monthlyValues: [],
    chartOfAccounts: [],
    trackings: []
  }

  try {
    const allLoadedData = await Promise.all(promises)
    console.log('allLoadedData', allLoadedData)

    // Concatene the values together
    allLoadedData.forEach(function (oneOrgData) {
      results.monthlyValues = results.monthlyValues.concat(oneOrgData.monthlyValues.monthlyValues)
      results.chartOfAccounts = results.chartOfAccounts.concat(oneOrgData.monthlyValues.chartOfAccounts)
      results.trackings = results.trackings.concat(oneOrgData.monthlyValues.trackings)
    })
  } catch (error) {
    console.warn('error', error)
    results.hasError = true
  }

  // Return
  console.log('results', results)
  return results
}

/**
 *
 * @param {*} orgId
 * @param {*} dates
 * @returns
 */
async function loadOneEntity (orgId, dates, orgData, otherParams) {
  console.log('loadOneEntity', dates, orgData)
  const monthFrom = dates.min || dayjs().add(-1, 'month').format('YYYY-MM')
  const monthTo = dates.max || dayjs().format('YYYY-MM')
  console.log('monthFrom', monthFrom, 'monthTo', monthTo)

  // Method: Without pagination
  try {
    const loadedData = await callApi('/api/pg-financials/data/:orgId/pg-monthly-values-with-balance-bs/:monthFrom/:monthTo', {
      orgId,
      monthFrom,
      monthTo
    })

    console.log('loadedData', loadedData)

    // Add the org info to each value
    loadedData?.monthlyValues?.monthlyValues?.forEach(function (oneValue) {
      oneValue.entity = orgData
    })

    if (otherParams.numberProgressStep > 1) {
      showElement('progressBar')
      const progressBar = document.getElementById('progressBar')
      const currentValue = progressBar?.getAttribute('value')

      const oneStepSize = 100 / otherParams.numberProgressStep
      const newValue = +currentValue + oneStepSize
      document.getElementById('progressBar')?.setAttribute('value', newValue)
    }

    return loadedData
  } catch (error) {
    console.warn('error', error)

    setElementHtml('feedbackMessage', 'Oops, an error occured. Refresh the page and try again')
    showElement('feedbackMessage')
    throw new Error(error)
  }
}

function getOrgData (context, orgId) {
  const org = context.browserAppAccount.data.entities?.find(function (one) {
    return one.id === orgId
  })

  return org
}
